<template>
    <div id="login" class="login-container">
        <div class="logo-box">
            <van-image
                fit="scale-down"
                :src="logoPath"
            />
        </div>
        <van-cell-group>
            <!-- 通过 pattern 进行正则校验 -->
            <van-field
                ref="userName"
                v-model="params.userName"
                name="tel"
                placeholder="请输入账号"
                @input="validatorUsn"
            />
            <!-- 通过 validator 进行函数校验 -->
            <van-field
                ref="password"
                v-model="params.password"
                name="pwd"
                type="password"
                placeholder="请输入密码"
                @input="validatorPwd"
            />
        </van-cell-group>
        <div class="submit-button">
            <van-button block :type="type" native-type="submit" :disabled="!(usernameValidator && pwdValidator)"
                        @click="login">提交
            </van-button>
        </div>
    </div>
</template>

<script>
import md5 from 'js-md5';
import {loginByPwd} from "@/api";
import {CellGroup, Field, Button, Toast} from 'vant'
import {debounce} from "lodash-es";

export default {
    name: "Login",
    props:['redirect'],
    components: {
        [CellGroup.name]: CellGroup,
        [Field.name]: Field,
        [Button.name]: Button
    },
    data() {
        return {
            logoPath: require(`@/assets/image/logo.png`),
            // 登录按钮类型
            type: 'default',
            params: {
                userName: '',// 用户名
                password: '',// 密码
            },
            usernameValidator: false,
            pwdValidator: false,
            // 登录按钮是否禁用
            loginDisabled: 'disabled'
        }
    },
    created() {
        this.$store.commit("toggleTabbarShow", false);
    },
    methods: {
        //验证账号
        validatorUsn() {
            this.params.userName.length == 0 || this.params.userName == '' ? this.usernameValidator = false : this.usernameValidator = true
        },
        //验证密码
        validatorPwd() {
            this.params.password.length == 0 || this.params.password == '' ? this.pwdValidator = false : this.pwdValidator = true
        },
        // 登录
        login() {
            let params = {
                userName: this.params.userName,
                password: md5(this.params.password),
            };
            let that = this;
            loginByPwd(params)
                .then(res => {
                    if (res.code != 200) {
                        this.errMsg = res.message;
                        Toast.fail(this.errMsg || '登录失败!')
                        // 密码输入错误时重新聚焦输入框
                        this.$refs.password.focus();
                    } else {
                        let params = this.redirect?{redirect:this.redirect}:null;
                        this.$store.commit('login', params);
                    }
                }).catch(err => {
                Toast.fail(err.message || '登录失败!')
            })
        },
    }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/theme/theme.scss";

.login-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0 45px;
    background: #fff;
    overflow-y: auto;

    .logo-box {
        .van-image{
            width: 168px;
            height: 123px;
        }
        width: 168px;
        height: 123px;
        margin: 80px auto 50px;
        //width: 100%;
        //height: 253px;
        //text-align: center;
        //display: flex;
        //align-content: center;
        //align-items: center;
        //text-align: center;
        //justify-content: center;
    }

    .van-cell-group {
        input {
            @extend .font13;
        }

        &::after {
            border-top: none;
            border-color: #F0F0F0;
        }
    }

    .van-cell::after {
        border-color: #F0F0F0;
    }

    .submit-button {
        margin-top: 35px;

        .van-button {
            color: #fff;
            background: #1678FF;
            border: none;
            border-radius: 5px;
            @extend .font14;
        }
    }
}
</style>
